import React from 'react';

import { onboardColors } from '../../theme/onboardTokens';
import { usePortalCompact } from '../usePortalCompact';

import type { PropsWithChildren } from 'react';

/**
 * Fixed bottom action bar shared by the portal's item screens. The inner row
 * mirrors Layout's content width so the buttons line up with the card's right edge.
 */
const PortalFooter: React.FC<PropsWithChildren> = ({ children }) => {
  const compact = usePortalCompact();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: onboardColors.surface.white,
        boxShadow: '0 -2px 10px rgba(57, 113, 138, 0.05)',
        padding: compact ? '12px 0' : '24px 0'
      }}
    >
      <div
        style={{
          maxWidth: 1016,
          margin: '0 auto',
          padding: compact ? '0 16px' : '0 24px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          gap: 12
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default PortalFooter;
